import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useEffect, useState } from "react";

/**
 * useGetLinkPerformance - 获取链接算力业绩（大链、小链、总业绩）
 */
const useGetLinkPerformance = () => {
    const { address, contractEvm: { QueryFunction } } = useConnectWallet();

    // 大链业绩
    const [bestLinkReward, setBestLinkReward] = useState<bigint>(BigInt(0));
    // 小链业绩
    const [smallLinkReward, setSmallLinkReward] = useState<bigint>(BigInt(0));
    // loading
    const [linkPerformanceLod, setLoading] = useState(false);

    /**
     * getLinkPerformance - 获取链接业绩数据
     */
    const getLinkPerformance = useCallback(async () => {
        if (!QueryFunction || !address) return;

        try {
            setLoading(true);

            // 调用合约方法获取链接业绩
            const res = await QueryFunction.getLinkPerformance(address);
            // 大链业绩

            setBestLinkReward(res._bestLinkReward);

            // 小链业绩
            setSmallLinkReward(res._smallLinkReward);


        } catch (error) {
            console.log('useGetLinkPerformance error:', error);
        } finally {
            setLoading(false);
        }
    }, [QueryFunction, address]);

    useEffect(() => {
        getLinkPerformance();
    }, [getLinkPerformance]);

    return {
        bestLinkReward,
        smallLinkReward,
        linkPerformanceLod,
        getLinkPerformance
    };
};

export default useGetLinkPerformance;
